import { User } from "./user";
import { UserAllowedCompaniesFactory } from "./user-allowed-companies.factory";
import { UserCompanyInfoFactory } from "./user-company-info.factory";
import { UserRoleListFactory } from "./user-role-list.factory";

export class UserFactory {
  static createUser(payload: any): User {
    const user = new User();
    if (payload) {
      user.setUserKey(payload.userkey);
      user.setActivate(payload.active);
      user.setRequiredTerm(payload.requiredTerm);
      user.setName(payload.name);
      user.setEmail(payload.email);
      user.setUserCompanyInfo(UserCompanyInfoFactory.createUserCompanyInfo(payload.userCompanyInfo));
      user.setAllowedCompanies(UserAllowedCompaniesFactory.createAllowedCompanies(payload.allowedCompanies));
      user.setUserRoleList(UserRoleListFactory.createUserRoleList(payload.userRoleList));
      return user;
    }
  }
}
